var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullScreenExit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 1.88882,10.7778 h 5.3334 v 5.33333",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.11113,7.22222 H 10.7778 v -5.3333",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 1L10.7778 7.22222",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 17L7.22222 10.7778",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreenExit);
export default __webpack_public_path__ + "static/media/full-screen-exit.2a159852646aaaf1b571a676b5d99c47.svg";
export { ForwardRef as ReactComponent };